import { Component, OnInit } from "@angular/core";
import { MemberappBaseComponent } from "../groupportal-base/groupportal-base.component";
import { FormGroup, Validators } from "@angular/forms";
import { EducationDetails } from "../../../shared/models";
import { EducationChildComponent } from "../_common";
import { AccountType, MemberType } from "../../../shared/enums/data.enums";

@Component({
  selector: "app-education",
  templateUrl: "./component2.component.html",
  styleUrls: ["./component2.component.scss"]
})
export class Component2Component extends MemberappBaseComponent {
  educationForm: FormGroup;
  educationDetails: EducationDetails;
  memberType: MemberType;
  AccountType: typeof AccountType = AccountType;
  MemberType: typeof MemberType = MemberType;

  get medicalSchool() {
    return this.educationForm.get("medicalSchool");
  }
  get residency() {
    return this.educationForm.get("residency");
  }
  get fellowship() {
    return this.educationForm.get("fellowship");
  }
  get boardCertification() {
    return this.educationForm.get("boardCertification");
  }
  get attest() {
    return this.educationForm.get("attest");
  }

  ngOnInit() {
    //this.loggerService.logInfo(this.groupPortalDataService.memberAppData);

    //reset
    this.resetForm();

    //subscriptions
  }

  ngAfterViewInit() {

  }

  resetForm() {
    this.memberType = this.groupPortalDataService.memberAppData.membershipDetails.memberType;
    this.educationDetails = this.groupPortalDataService.memberAppData.educationDetails;

    this.educationForm = this.fb.group({
      medicalSchool: EducationChildComponent.buildForm_MS(
        this.educationDetails.medicalSchool,
        this.fb,
        this.memberType
      ),

      residency: EducationChildComponent.buildForm_R(
        this.educationDetails.residency,
        this.fb,
        this.memberType
      ),

      fellowship: EducationChildComponent.buildForm_F(
        this.educationDetails.fellowship,
        this.fb,
        this.memberType
      ),

      boardCertification: EducationChildComponent.buildForm_B(
        this.educationDetails.boardCertification,
        this.fb,
        this.memberType
      ),

      attest: [
        false,
        Validators.compose(
          this.memberType == MemberType.Physician
            ? [Validators.requiredTrue]
            : []
        )
      ]
    });

    //Set Validations based on Member Type

    //this.residency.disable();
    // this.fellowship.disable();
    // this.boardCertification.disable();

    // if (this.memberType == MemberType.Student) {
    //   this.helperService.ClearValidators(this.residency as FormGroup);

    // } else if (this.memberType == MemberType.Resident) {
    //   this.residency.enable();
    // } else if (this.memberType == MemberType.Fellow) {
    //   this.residency.enable();
    //   this.fellowship.enable();
    // } else if (this.memberType == MemberType.Physician) {
    //   this.residency.enable();
    //   this.fellowship.enable();
    //   this.boardCertification.enable();
    // }
  }

  save() {
    //disable the address in bc to prevent validation errors
    this.boardCertification.get("address").disable();
    //let c  = this.residency.get('accountLookUp.name')

    super.onSave(this.educationForm);

    if (this.educationForm.valid) {
      // this.educationForm.dirty
      if (
        this.medicalSchool.dirty ||
        this.residency.dirty ||
        this.fellowship.dirty ||
        this.boardCertification.dirty
      ) {
        // Copy the form values over the product object values
        this.educationDetails = this.component2Service.prepareDataModel(
          this.educationDetails,
          this.educationForm
        );
        if (
          !this.component2Service.validateGradDates(
            this.educationDetails,
            this.memberType
          )
        ) {
          this.globalDomOpsService.notify(
            "Graduation dates are not in chronological order. Please correct it to proceed further.",
            "",
            "error"
          );
          return false;
        }

        this.loggerService.logInfo(this.educationDetails);
        this.component2Service
          .saveEducationDetails(this.educationDetails)
          .subscribe(
            (t: any) => {
              this.educationDetails = t;
              this.onSaveComplete(this.educationDetails);
            },
            (error: any) => {
              this.errorMessage = <any>error;
              super.onError();
            }
          );
      } else {
        this.onSaveComplete();
      }
    }
  }

  onSaveComplete(d?: EducationDetails) {
    this.groupPortalDataService.memberAppData.educationDetails = this.educationDetails;
    this.globalDomOpsService.notify("Education Details Updated");
    let nextRoute = "component1";

    if (!!d) {
      //this.groupPortalDataService.ResetGroupPortalData();
      this.globalDomOpsService.showwait();

    } else {
      this.groupPortalDataService.navigateToRoute(nextRoute);
    }
  }
}
